// components/TermsOfService.jsx
import React from 'react';
import '../styles/PrivacyPolicy.css'; // Reuse the same styles

const TermsOfService = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="privacy-policy-page">
      {/* Header */}
      <div className="privacy-policy-header">
        <div className="privacy-policy-header-bg">
          <div className="privacy-policy-header-circle privacy-policy-header-circle-1"></div>
          <div className="privacy-policy-header-circle privacy-policy-header-circle-2"></div>
        </div>
        <div className="privacy-policy-header-content">
          <h1 className="privacy-policy-title">Terms of Service</h1>
          <p className="privacy-policy-subtitle">
            Please read these terms carefully before using our services.
          </p>
          <p className="privacy-policy-date">Last Updated: January 1, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">1. Acceptance of Terms</h2>
            <p className="privacy-policy-section-text">
              By using the PlumberPro website and services, you agree to be bound by these 
              Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">2. Services Provided</h2>
            <p className="privacy-policy-section-text">
              PlumberPro provides plumbing services including but not limited to:
            </p>
            <ul className="privacy-policy-ul">
              <li>Emergency plumbing repairs</li>
              <li>Bathroom and kitchen installations</li>
              <li>Drain cleaning and unclogging</li>
              <li>Water heater repair and installation</li>
              <li>Pipe repair and replacement</li>
              <li>Toilet repair and installation</li>
              <li>Sewer line services</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">3. Booking and Appointments</h2>
            <p className="privacy-policy-section-text">
              When you book a service with us:
            </p>
            <ul className="privacy-policy-ul">
              <li>You agree to provide accurate and complete information</li>
              <li>You agree to be available at the scheduled appointment time</li>
              <li>You agree to pay the quoted price for services rendered</li>
              <li>Cancellations require at least 2 hours notice</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">4. Pricing and Payment</h2>
            <p className="privacy-policy-section-text">
              All prices are quoted in US dollars. Payment is due upon completion of services.
              We accept all major credit cards, debit cards, and cash payments.
            </p>
            <p className="privacy-policy-section-text">
              Upfront pricing is provided before any work begins. Any additional work outside 
              the original scope will be quoted and approved before proceeding.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">5. User Responsibilities</h2>
            <p className="privacy-policy-section-text">
              You agree to:
            </p>
            <ul className="privacy-policy-ul">
              <li>Provide safe access to the work area</li>
              <li>Inform us of any known hazards or issues</li>
              <li>Not misuse or abuse our services</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">6. Limitation of Liability</h2>
            <p className="privacy-policy-section-text">
              PlumberPro is not liable for any indirect, incidental, or consequential damages 
              arising from the use of our services. Our total liability is limited to the 
              amount paid for the specific service rendered.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">7. Warranty</h2>
            <p className="privacy-policy-section-text">
              We stand behind our work with a satisfaction guarantee. If you are not satisfied 
              with our service, contact us within 30 days and we will make it right.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">8. Intellectual Property</h2>
            <p className="privacy-policy-section-text">
              All content on this website, including text, graphics, logos, and images, is the 
              property of PlumberPro and is protected by copyright laws.
            </p>
          </section>

          <section className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">9. Changes to Terms</h2>
            <p className="privacy-policy-section-text">
              We reserve the right to update these Terms of Service at any time. Changes will 
              be posted on this page with an updated date.
            </p>
          </section>

          <section className="privacy-policy-section privacy-policy-contact">
            <h2 className="privacy-policy-section-title">10. Contact Us</h2>
            <p className="privacy-policy-section-text">
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <div className="privacy-policy-contact-info">
              <div className="privacy-policy-contact-item">
                <span>📞</span>
                <div>
                  <strong>Phone:</strong>
                  <a href="tel:+18334936242">+1 (833) 493-6242</a>
                </div>
              </div>
              <div className="privacy-policy-contact-item">
                <span>✉️</span>
                <div>
                  <strong>Email:</strong>
                  <a href="mailto:info@plumberpro.com">info@plumberpro.com</a>
                </div>
              </div>
            </div>
          </section>

          <button className="privacy-policy-back-top" onClick={scrollToTop}>
            ↑ Back to Top
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;